var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title:
          "Recibido de Contraloría para el Expediente " +
          _vm.controlFile.numero,
        "no-close-on-backdrop": "",
        centered: "",
        "hide-footer": "",
        "content-class": "fullscreen",
        size: "xl"
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", { staticClass: "row", attrs: { id: "management" } }, [
        _c("div", { staticClass: "col-8" }, [
          !_vm.selectedFile
            ? _c("div", [
                _c("h4", { staticClass: "text-primary" }, [
                  _vm._v(
                    " Por favor carga el archivo recibido de contraloría para continuar con su tramitación "
                  )
                ])
              ])
            : _vm._e(),
          _vm.selectedFile
            ? _c("div", { staticClass: " d-flex shadow bg-gray" }, [
                _c(
                  "div",
                  {
                    ref: "pdfViewport",
                    staticClass: "container-pdf position-relative page"
                  },
                  [
                    _vm._l(_vm.numPages, function(i) {
                      return _c("pdf", {
                        key: i,
                        staticClass: "m-auto",
                        attrs: { page: i, src: _vm.selectedFile }
                      })
                    }),
                    _vm.sign
                      ? _c("drag-sign-office", {
                          ref: "sign",
                          attrs: {
                            position: _vm.positionSign,
                            "process-type": "Tramitar"
                          }
                        })
                      : _vm._e()
                  ],
                  2
                )
              ])
            : _vm._e()
        ]),
        _c("div", { staticClass: "col-4" }, [
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c("UploadFile", {
                attrs: {
                  permission: "*",
                  text: "Cargar documento",
                  "upload-to": _vm.urlFile,
                  "button-class": "",
                  "container-class": "text-right"
                },
                on: {
                  input: function($event) {
                    return _vm.addFile()
                  }
                },
                model: {
                  value: _vm.file,
                  callback: function($$v) {
                    _vm.file = $$v
                  },
                  expression: "file"
                }
              })
            ],
            1
          ),
          _c(
            "form",
            {
              staticClass: "mt-4",
              attrs: { "data-vv-scope": "sign-document" }
            },
            [
              _c("div", [
                _c(
                  "div",
                  { staticClass: "mt-3" },
                  [
                    _c("label", [_vm._v("Fecha")]),
                    _c("b-form-datepicker", {
                      staticClass: "w-100",
                      attrs: {
                        max: _vm.max,
                        id: "example-datepicker",
                        "label-help":
                          "Puede usar las flechas del teclado y espacio"
                      },
                      model: {
                        value: _vm.manageDate,
                        callback: function($$v) {
                          _vm.manageDate = $$v
                        },
                        expression: "manageDate"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "mt-3" },
                  [
                    _c(
                      "vs-select",
                      {
                        staticClass: "w-100 con-select autocompletex",
                        attrs: {
                          autocomplete: "",
                          label: "Seleccione tipo de Firma"
                        },
                        model: {
                          value: _vm.signType,
                          callback: function($$v) {
                            _vm.signType = $$v
                          },
                          expression: "signType"
                        }
                      },
                      _vm._l(_vm.userSignConfiguration.userSigns, function(
                        firma
                      ) {
                        return _c("vs-select-item", {
                          key: firma.id,
                          attrs: { value: firma, text: firma.proveedor }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "mt-3" },
                  [
                    _c("vs-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "w-100",
                      attrs: {
                        label: "Código OTP",
                        maxlength: "6",
                        name: "otp",
                        danger: _vm.errors.has("sign-document.otp"),
                        "danger-text": _vm.errors.first("sign-document.otp")
                      },
                      model: {
                        value: _vm.otpCode,
                        callback: function($$v) {
                          _vm.otpCode = $$v
                        },
                        expression: "otpCode"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          ),
          _c(
            "div",
            {
              staticClass: "m-top-20",
              staticStyle: { display: "flex", "justify-content": "flex-end" }
            },
            [
              _c(
                "vs-button",
                {
                  attrs: { color: "dark", type: "border" },
                  on: {
                    click: function($event) {
                      return _vm.cancelProcess()
                    }
                  }
                },
                [_vm._v("Cancelar")]
              ),
              _vm.otpCode !== ""
                ? _c(
                    "vs-button",
                    {
                      staticStyle: { "margin-left": "12px" },
                      attrs: { color: "primary", type: "border" },
                      on: {
                        click: function($event) {
                          return _vm.processFile()
                        }
                      }
                    },
                    [_vm._v(" Tramitar expediente ")]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }